import { AreaTicketIndicatorsDTO } from '../models/ResponsibleTicketIndicators'
import { TicketRepository } from '../repositories/TicketRepository'

export function ListTicketIndicatorsCase(ticketRepository: TicketRepository) {
  return async function (data: AreaTicketIndicatorsDTO) {
    return await ticketRepository.listTicketIndicators({ data })
  }
}
